import * as React from 'react';

import {Button} from 'shells/button/button';
import {Checkbox} from 'shells/checkbox/checkbox';
import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {Body} from 'shells/typography/body';

type Props = {
    resubscribeUrl?: string;
    onSuccessfulResubscribe: () => void;
};

export function UnsubscribedPage(props: Props) {
    const [isResubscribed, setIsResubscribed] = React.useState(false);

    return (
        <div className='py-32'>
            <StackLegacy spacing={20}>
                <Body color='light'>
                    You&apos;re unsubscribed from all content and will not receive any additional
                    emails
                </Body>
                <Checkbox
                    // @ts-expect-error
                    id='resubscribe'
                    name='resubscribe'
                    checked={isResubscribed}
                    onChange={() => setIsResubscribed(!isResubscribed)}
                    label={
                        <div className='px-8'>
                            <Body color='dark' isBold={true}>
                                Resubscribe me to email communication
                            </Body>
                        </div>
                    }
                />
                <Button
                    size='xlarge'
                    variant='primary'
                    isFullWidth={true}
                    disabled={!isResubscribed}
                    onClick={() => {
                        if (props.resubscribeUrl) {
                            Nut.ajax.post({
                                url: props.resubscribeUrl,
                                data: {audienceIds: []},
                                success: props.onSuccessfulResubscribe,
                            });
                        }
                    }}
                >
                    Save
                </Button>
            </StackLegacy>
        </div>
    );
}
